// extracted by mini-css-extract-plugin
export default {"Overlay":"user-notice-popover-module__Overlay--U2X3U","PointerBox":"user-notice-popover-module__PointerBox--AJS8O"};